export default __webpack_public_path__ + "static/media/bell.222cf98f.svg";